const userRoles = {
    OPERATOR: 1,
    DISPATCH: 2,
    THIRD_PARTY: 3,
    CUSTOMER_SERVICE: 4,
    EXTERNAL_DISPATCH: 5,
    AUCTION_BUYER: 6,
    HAULER: 7,
    ADMINISTRATOR: 9,
}

export default Object.freeze(userRoles);


// WEBPACK FOOTER //
// ./src/utils/applicationRoles.js